import React from 'react'
import './PageLogosRow.scss'

const PageLogosRow = ({children}) => {
    const displayItems = Math.min(children.length, 6)

    return (
        <div className="page__logos-row" style={{'--display-items': displayItems}}>
            {children}
        </div>
    )
}

export default PageLogosRow
